import clsx from 'clsx';
import React from 'react';
import i18n from '@i18n';
import './Footer.less';
import './FooterPartners.less';
import { getConfigProperty, getProperty, getUrl } from '@/common/oldMobile';

import FacebookIcon from '@/icons/FacebookIcon';
import InstagramIcon from '@/icons/InstagramIcon';
import LinkedInIcon from '@/icons/LinkedInIcon';
import YouTubeIcon from '@/icons/YouTubeIcon';
import DesktopLinkIcon from 'nike-ui/src/icons/svg/desktop-link-icon-sv.svg';
import stringToBoolean from '../../stringToBoolean';
import {
    COMMUNITY_CHAT,
    TOURNAMENTS_RANKING,
    TURBO_LIVE_SPORT,
    TURBO_LIVE_MATCH_DETAIL,
    REGISTRATION,
    LAW,
    NIKE1_MATCH,
    NIKE1_DETAIL
} from '@/routing/routes';
import { isRegistrationRoute } from '@/routing/routeutils';
import { FooterLinks } from './FooterLinks';
import FooterPartnerLogos from '@/common/components/footer/FooterPartnerLogos';
import Plus18 from '@/common/components/footer/img/18Plus.webp';
import { useIsEmbeddedLocation } from 'nike-ui/src/components/registration/hook/useIsEmbeddedLocation';
import FooterPaymentMethods from '@/common/components/footer/FooterPaymentMethods';
import { FooterMediaServiceStatement } from 'nike-ui/src/components/footer/components/FooterMediaServiceStatement';

const responsive = stringToBoolean(getConfigProperty('responsive'));

export function Footer({ route, closingModePadding }) {
    const embedded = useIsEmbeddedLocation();
    if (
        [COMMUNITY_CHAT, TURBO_LIVE_SPORT, TURBO_LIVE_MATCH_DETAIL, NIKE1_MATCH, NIKE1_DETAIL].includes(route) ||
        route === TOURNAMENTS_RANKING ||
        (route === REGISTRATION && embedded)
    ) {
        return null;
    }

    return (
        <div
            className={clsx('footer', {
                'footer-reg': isRegistrationRoute(route),
                'footer-perex-mobile': closingModePadding
            })}
            data-section="footer"
        >
            <FooterLinks />
            <FooterPartnerLogos />
            <FooterDelimiter />
            <FooterPaymentMethods />
            <FooterDelimiter />
            <FooterPortalVersionLink />
            <SocialLinks />
            <FooterMediaServiceStatement href={`${LAW.path}#niketv`} className="c-link-default" />
            <FooterPerex />
        </div>
    );
}

const FooterDelimiter = () => <div className="footer-delimiter br-t-default mt-10 mb-10" />;

function FooterPortalVersionLink() {
    const standaloneMode = window.matchMedia('(display-mode: standalone)').matches;

    if (standaloneMode || window.navigator.userAgent.indexOf('MSAppHost') > -1) {
        return null;
    }

    return (
        <a
            title="Počítačová verzia webu"
            href={'/' + getUrl('DEVICE_URL_PC')}
            data-atid="footer-desktop-version"
            className="footer-desktop-version"
        >
            <DesktopLinkIcon />
            <span>{i18n('common.desktop.version')}</span>
        </a>
    );
}

export function BetslipFooter() {
    return (
        <div className="footer footer-betslip">
            <FooterPerex />
        </div>
    );
}

function FooterPerex() {
    const version = getProperty('nikeVersion');
    return (
        <div
            className="footer-perex"
            title={version.build + ', ' + version.server + (responsive ? ', responsive' : '')}
        >
            <div>{i18n('footer.nikeIncAffiliation')}</div>
            <br />
            <div>
                {i18n('footer.row.1')}
                <img src={Plus18} alt="(18+)" height="20px" className="ml-3 vertical-middle" />
            </div>
            <div>{i18n('footer.row.2')}</div>
        </div>
    );
}

function SocialLinks() {
    return (
        <div className="social-buttons">
            <a
                title="Niké Facebook"
                data-atid="footer-facebook"
                href="https://www.facebook.com/NIKEjetipovanie"
                rel="noopener noreferrer"
                target="_blank"
            >
                <FacebookIcon width="30" height="30" fill={'#000'} opacity={0.5} />
            </a>
            <a
                title="Niké LinkedIn"
                data-atid="footer-linkedin"
                href="https://www.linkedin.com/company/n-i-k-%C3%A9-spol.-s-r.o.?trk=top_nav_home"
                rel="noopener noreferrer"
                target="_blank"
            >
                <LinkedInIcon width="30" height="30" fill={'#000'} opacity={0.5} />
            </a>
            <a
                title="Niké Youtube"
                data-atid="footer-youtube"
                href="https://www.youtube.com/channel/UClshSSm4fl61NQ1fKEkHbUQ"
                rel="noopener noreferrer"
                target="_blank"
            >
                <YouTubeIcon width="30" height="30" fill={'#000'} opacity={0.5} />
            </a>
            <a
                title="Niké Instagram"
                href="https://www.instagram.com/nike_je_tipovanie/"
                rel="noopener noreferrer"
                data-atid="footer-instagram"
                target="_blank"
            >
                {/*@ts-ignore*/}
                <InstagramIcon width="30" height="30" fill={'#000'} opacity={0.7} />
            </a>
        </div>
    );
}
